module.exports = __webpack_public_path__ + "1401af9a2c8fe0abc6bf440364a305ea.svg";